<template>
  <div>
    <contents-box>
      <loader-simple :flag="flag.loader">
        <ul v-if="!flag.loader">
          <stack-item
            v-for="row of counselors"
            :key="row.id">
            <counselor-box :counselor="row" :showDetail="openIds.includes(row.id)">
              <template v-slot:btn>
                <spacer :y="2"/>
                <div :class="$style.open" v-on:click="changeOpenIds(row.id)">
                  <p v-if="!openIds.includes(row.id)">詳細を表示<i class="fa-regular fa-angles-down"/></p>
                  <p v-if="openIds.includes(row.id)">詳細を非表示<i class="fa-regular fa-angles-up"/></p>
                </div>
              </template>
              <template v-slot:other>
                <spacer :y="2"/>
                <btn-container>
                  <basic-btn
                    :to="`/reserve/select/?target=counselor&counselor=${row.id}`"
                    size="sm">この先生にオンライン相談する</basic-btn>
                </btn-container>
              </template>
            </counselor-box>
          </stack-item>
        </ul>
      </loader-simple>
    </contents-box>
  </div>
</template>

<script>
import BasicBtn from '@/views/components/BasicBtn.vue';
import CounselorBox from '@/views/components/CounselorBox.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import StackItem from '@/views/components/StackItem.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import Spacer from '@/views/components/Spacer.vue';
import { TEST_COUNSELOR_IDS } from '@/constants/counselor';

export default {
  name: 'counselors',
  components: {
    BasicBtn,
    BtnContainer,
    CounselorBox,
    StackItem,
    ContentsBox,
    LoaderSimple,
    Spacer,
  },
  data() {
    return {
      flag: {
        loader: true,
      },
      counselors: [],
      openIds: [],
    };
  },
  created() {
    this.getCounselors(22); // まずは心理士を取得
  },
  methods: {
    getCounselors(accountType) {
      this.axios({
        method: 'GET',
        url: '/v1/user/get/list',
        params: {
          accountTypes: [accountType],
          order: 'kana',
          orderBy: 'asc',
        },
      })
        .then((response) => {
          if (response.data.users.data.length) {
            // テスト心理士は表示対象から除外する
            const counselorsExcludeTest = response.data.users.data.filter(
              (user) => !TEST_COUNSELOR_IDS.includes(user.id),
            );
            this.counselors = this.counselors.concat(counselorsExcludeTest);
          }
          // 表示完了処理
          if (accountType === 22) {
            this.getCounselors(21); // 続けて医師を取得
          } else if (accountType === 21) {
            this.flag.loader = false; // 全て取得完了
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    changeOpenIds(id) {
      if (this.openIds.includes(id)) {
        const idx = this.openIds.indexOf(id);
        this.openIds.splice(idx, 1);
      } else {
        this.openIds.push(id);
      }
    },
  },
};
</script>

<style lang="scss" module>
.open {
  font-size: 12px;
  font-weight: normal;
  color: var(--gray-side);
  cursor: pointer;
  display: flex;
  justify-content: center;
  i {
    margin-left: 4px;
  }
}
</style>
